import { FooterLinks } from "@/containers/Layout/MainLayout/styled";
import { Col, Divider, Layout, Row } from "antd";
import { useIntl } from "react-intl";

const { Footer } = Layout;

const rowStyle = {
  padding: "0",
};

const PageFooter = () => {
  const intl = useIntl();

  return (
    <Footer>
      <Row style={rowStyle} justify="start">
        <Col span={4}>
          <span>© {new Date().getFullYear()} - Milwaukee Tool</span>
        </Col>
        <Col span={16}>
          <Row style={rowStyle} gutter={4} justify="center">
            <Col>
              <FooterLinks
                data-test-id="page-footer-legal-link"
                href="https://www.milwaukeetool.com/Footer/Legal"
                target="_blank"
              >
                {intl.formatMessage({ id: "footer.legal" })}
              </FooterLinks>
            </Col>
            <Divider type="vertical" />
            <Col>
              <FooterLinks
                data-test-id="page-footer-privacy-policy-link"
                href="https://www.milwaukeetool.com/Footer/Privacy"
                target="_blank"
              >
                {intl.formatMessage({ id: "footer.privacyPolicy" })}
              </FooterLinks>
            </Col>
            <Divider type="vertical" />
            <Col>
              <FooterLinks
                data-test-id="page-footer-milwaukee-tool-link"
                href="https://www.milwaukeetool.com/"
                target="_blank"
              >
                milwaukeetool.com
              </FooterLinks>
            </Col>
          </Row>
        </Col>
        <Col span={4}></Col>
      </Row>
    </Footer>
  );
};

export default PageFooter;
